import api from '../api';

export interface DocumentoCobranca {
  id: string;
  tipo: string;
  estabelecimento?: string;
  valor?: number;
  numeroContrato?: string;
  fornecedor?: string;
  natureza?: string;
  serie?: string;
  qtdParcela?: number;
  condicaoPagamento?: string;
  parcelas: Parcela[];
}

export interface Parcela {
  id: string;
  parcelaCobrancaNumero?: string;
  condicaoPagamento?: string;
  dataPrevisaoPagamento?: string;
  valor?: number;
  numeroTitulo?: string;
  especieTitulo?: string;
}

export const getDocumentoCobrancaWithParcelas = (autorizacaoId: string) =>
  api.get<DocumentoCobranca>(`autorizacoes/documentoWithParcelas/${autorizacaoId}`);

